import { ContentType } from "@pdfking/structs"

import { ResponseHeader } from "./ResponseHeader"

/**
 * Gets Content-Type from response, excluding charset.
 *
 * Extracts MIME type from Content-Type header, removing parameters.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @param cttp - Default content type (default: "application/octet-stream")
 * @returns MIME type in lowercase
 *
 * @example
 * ```ts
 * import { ResponseContentType } from "@pdfking/io"
 *
 * const mimeType = ResponseContentType(response)
 * // "application/json" from "application/json; charset=utf-8"
 * ```
 */
export const ResponseContentType = (
  r: Request | Response | XMLHttpRequest,
  cttp: ContentType = ContentType.BYTES
): ContentType =>
  // The one place a header becomes a type: whatever a server says it sent is
  // taken at its word, the enum being the names this codebase has for the ones
  // it knows rather than a list of what may arrive.
  ResponseHeader(r, "content-type", cttp).split(";")[0].toLowerCase() as ContentType
